import type React from 'react'

import { ProjectFavicon } from './components'
import css from './styles.module.css'

interface Props {
  url: string
  favicon: string | null
  title: string | null
}

export const ProjectInfoCard: React.FC<Props> = ({ url, favicon, title }) => {
  const domain = new URL(url).hostname

  return (
    <div className={css.project_info_card}>
      <ProjectFavicon favicon={favicon} />

      <div className={css.project_info_text}>
        <div className={css.project_info_domain}>
          <a
            href={url}
            className={css.project_info_link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {domain}
          </a>
        </div>
        <div className={css.project_info_title}>{title || domain}</div>
      </div>
    </div>
  )
}
